import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SectionHeading } from "@/components/Reveal";
import { CtaBand } from "@/components/CtaBand";
import { ProjectCard } from "@/components/ProjectCard";

export default function Portfolio() {
  const { t } = useLang();
  const [filter, setFilter] = useState("all");
  const visible = t.projects.filter((p) => filter === "all" || p.category === filter);

  const cellClass = (p, i) => {
    if (filter === "all" && i === 0)
      return "md:col-span-12 h-[320px] sm:h-[420px] lg:h-[560px]";
    return "md:col-span-6 h-[300px] sm:h-[360px] lg:h-[440px]";
  };

  return (
    <>
      <section className="pb-12 pt-36 sm:pt-44">
        <div className="wrap">
          <SectionHeading
            eyebrow={t.portfolioPage.hero.eyebrow}
            title={t.portfolioPage.hero.title}
            sub={t.portfolioPage.hero.sub}
          />
        </div>
      </section>

      <section className="pb-24">
        <div className="wrap">
          <div className="flex flex-wrap gap-2 border-t border-sand pt-8" data-testid="portfolio-filters">
            {t.categories.map((c) => (
              <button
                key={c.id}
                data-testid={`portfolio-filter-${c.id}`}
                onClick={() => setFilter(c.id)}
                className={`rounded-full border px-4 py-2 text-xs transition-all duration-300 sm:text-sm ${
                  filter === c.id
                    ? "border-espresso bg-espresso text-offwhite"
                    : "border-sand text-taupe hover:border-teak hover:text-teak"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          <motion.div layout className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-12">
            <AnimatePresence mode="popLayout">
              {visible.map((p, i) => (
                <motion.div
                  key={p.id}
                  layout
                  initial={{ opacity: 0, scale: 0.96 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.96 }}
                  transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                  className={cellClass(p, i)}
                >
                  <ProjectCard p={p} testid={`portfolio-card-${p.id}`} />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
